<template>
    <b-container>
        <div class="teams">
            <h1>{{ (userType == 'src') ? 'SRC' : 'Admin'  }}</h1>
            <div>
                <router-link v-if="isAdmin" :to="{ name: (userType == 'src') ? 'NewSrc' : 'NewUser' }" class
                    >+Add {{ (userType == 'src') ? 'Src' : 'Admin'  }}</router-link
                >
            </div>
            <b-col  class="my-1">
                <b-form-group
                label="Filter"
                label-for="filter-input"
                label-cols-sm="1"
                label-size="sm"
                class="mb-0"
                >
                <b-input-group size="sm">
                    <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                    ></b-form-input>

                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-col>

            <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="users"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="cell(user_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditSrc', params: { id: row.item.uuid } }"
                    >{{ row.item.user_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                 <template slot="cell(user_type)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.user_type }}</p>
                </template>
                <template slot="cell(active)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.active }}</p>
                </template>
                <template slot="cell(uuid)" slot-scope="row" v-if="isAdmin">
                   
                    <br />
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'UserProfile', params: { id: row.item.uuid,type:'src'} }"
                    >
                        <b-button class="info">Edit User</b-button>
                    </b-link
                    >
                    <br />
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="users.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>
        </div>
    </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import UserService from "@/services/UsersService";
import router from '@/router';

export default {
    name:"SrcList",
    data(){
        return {
             fields: [
            { key: "user_name", label: "Name", sortable: true },
            { key: "user_type", label: "User Type" },
            // { key: "active", label: "Active" },
        //    { key: "uuid", label: "Active" },
        ],
        currentPage: 1,
        perPage: 5,
        filter: null,
        users:[],
        userType:null
        }
    },
    methods:{
        ...mapActions({
            REMOVE_TEAM_ID: "cluster/REMOVE_TEAM_ID",
            ADD_TEAM_ID: "cluster/ADD_TEAM_ID",
        }),
        stopClick() {},
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async fetchUsers(){
            if(this.userType == 'src'){
             var tmp = await UserService.getSrcUsers();
            }else{
             var tmp = await UserService.getAdminUsers();
            }
           this.users = tmp.data.results;
        }
    },
    computed: {
        ...mapGetters({
        isAdmin: "auth/isAdmin",
        }),
    },
    created(){
        var pathArray = router.currentRoute.path.split("/");
        this.userType = pathArray[pathArray.length - 1];
        console.log(pathArray[pathArray.length - 1]);
        this.fetchUsers();
        if(this.isAdmin){
           this.fields.push({key:"uuid", label:"Action"});
        }
    }    
}
</script>